import { Controller } from "@hotwired/stimulus"

// A poll replaces the tail DOM. Keep only IDs and disclosure state between polls
// so existing summaries don't replay their arrival animation.
const histories = new Map()

export default class extends Controller {
  static targets = ["step", "disclosure"]
  static values = { key: String, running: Boolean }

  connect() {
    this.history = histories.get(this.keyValue) || { seen: new Set(), open: false, running: this.runningValue }
    if (this.history.running && !this.runningValue) this.history.open = false
    this.history.running = this.runningValue
    let arriving = 0
    this.stepTargets.forEach(step => {
      if (this.runningValue && !this.history.seen.has(step.dataset.stepId)) {
        step.classList.add("is-emerging")
        step.style.animationDelay = `${Math.min(arriving++, 3) * 90}ms`
      }
      this.history.seen.add(step.dataset.stepId)
    })
    if (this.hasDisclosureTarget) this.disclosureTarget.open = this.history.open
    histories.set(this.keyValue, this.history)
    if (histories.size > 200) histories.delete(histories.keys().next().value)
  }

  remember() {
    if (!this.runningValue && this.hasDisclosureTarget) this.history.open = this.disclosureTarget.open
  }
}
